import { LayerTypeId } from "../generated/enums"
import { Datalayer } from "./datalayer"
import { DatalayerFactoryFunction, IDataLayer, IDatalayerContext, IDatalayerFactory, IDatalayerMapInstance, IDatalayerOptions } from "./types"

export class DatalayerFactoryProvider implements ng.IServiceProvider {


    private _factories: { [key: number]: DatalayerFactoryFunction };

    constructor() {
        this._factories = {};
    }

    $get() {
        return new DatalayerFactory(this._factories);
    }

    register(typeId: LayerTypeId, factory: DatalayerFactoryFunction) {

        this._factories[typeId] = factory;

    }

}

export class DatalayerFactory implements IDatalayerFactory {

    constructor(private _factories: { [key: number]: DatalayerFactoryFunction }) {
    }

    create(layer: IDataLayer, context: IDatalayerContext, options?: IDatalayerOptions) {

        let mapLayer: IDatalayerMapInstance
        let factory = this._factories[layer.TypeId]

        if (factory) mapLayer = factory(layer, context, options)

        if (!mapLayer) {
            mapLayer = new Datalayer(layer, context, options)
        }

        return mapLayer

    }

}
